module.exports = __webpack_public_path__ + "static/media/lundbeck.c4da479c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/forside/lundbeck.jpg
// module id = 1473
// module chunks = 0